// Module-level delivery country so the axios interceptor (non-React) can read it.
let current = 'DE';
try {
  const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('deliveryCountry') : null;
  if (stored) current = stored;
} catch {
  /* ignore */
}

export const getDeliveryCountry = (): string => current;

export const setDeliveryCountry = (code: string): void => {
  current = (code || 'DE').toUpperCase();
  try {
    localStorage.setItem('deliveryCountry', current);
  } catch {
    /* ignore */
  }
};
